import { render, staticRenderFns } from "./CreatePerson.vue?vue&type=template&id=61d0dfba&scoped=true&lang=pug&"
import script from "./CreatePerson.vue?vue&type=script&lang=js&"
export * from "./CreatePerson.vue?vue&type=script&lang=js&"
import style0 from "./CreatePerson.vue?vue&type=style&index=0&id=61d0dfba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d0dfba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/Kou/projects/vue-projects/joseph/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VFlex,VIcon,VRadio,VRadioGroup,VTextField})
